/**
 * Weekly Menu Countdown - Alpine.js Component
 * 
 * Displays a countdown timer for the Weekly Menu ordering window:
 * - Opens: Thursday 00:00:00 Copenhagen time
 * - Closes: Tuesday 23:59:59 Copenhagen time
 * 
 * Uses Intl.DateTimeFormat for accurate timezone handling (Europe/Copenhagen)
 * Automatically handles DST transitions
 */

if (!window.Eurus.loadedScript.has('weekly-menu-countdown.js')) {
  window.Eurus.loadedScript.add('weekly-menu-countdown.js');

  function registerCountdownComponent() {
    console.log('[Countdown] Registering Alpine component');
    Alpine.data('xWeeklyMenuCountdown', (config) => ({
        // Configuration from Liquid
        labelDays: config.labelDays || 'dage',
        labelHours: config.labelHours || 'timer',
        labelMinutes: config.labelMinutes || 'minutter',
        labelSeconds: config.labelSeconds || 'sekunder',
        showSeconds: config.showSeconds !== false,
        expireAction: config.expireAction || 'show_message',
        closedMessage: config.closedMessage || 'Bestilling lukket',
        closedHelper: config.closedHelper || 'Ny menu tilgængelig torsdag',

        // Countdown state
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isExpired: false,

        // Internal state
        interval: null,
        deadline: null,
        lastDeadlineCheck: null,

        /**
         * Initialize the countdown component
         */
        init() {
          console.log('Weekly Menu Countdown: Initializing...');
          try {
            this.calculateDeadline();
            console.log('Weekly Menu Countdown: Deadline set to', new Date(this.deadline).toLocaleString('da-DK', { timeZone: 'Europe/Copenhagen' }));
            this.updateCountdown();
            console.log('Weekly Menu Countdown: Initial values -', { days: this.days, hours: this.hours, minutes: this.minutes, seconds: this.seconds });
            this.startCountdown();
            console.log('Weekly Menu Countdown: Started successfully');
          } catch (error) {
            console.error('Weekly Menu Countdown: Initialization failed', error);
            // Fallback: show zeros instead of breaking completely
            this.isExpired = false;
            this.days = 0;
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
          }
        },

        /**
         * Calculate the next Tuesday 23:59:59 in Copenhagen timezone
         * Simplified approach that works reliably across timezones
         */
        calculateDeadline() {
          const now = new Date();
          
          // Get what day it is RIGHT NOW in Copenhagen timezone
          const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Copenhagen',
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
          
          const parts = formatter.formatToParts(now);
          const weekdayPart = parts.find(p => p.type === 'weekday');
          const hourPart = parts.find(p => p.type === 'hour');
          const minutePart = parts.find(p => p.type === 'minute');
          
          // Convert Copenhagen weekday to number (0 = Sunday)
          const dayMap = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
          const cphDay = dayMap[weekdayPart.value];
          const cphHour = parseInt(hourPart.value);
          const cphMinute = parseInt(minutePart.value);
          
          // Calculate days until next Tuesday
          let daysUntilTuesday;
          
          if (cphDay === 2) {
            // It's Tuesday in Copenhagen
            // Check if we're past 23:59
            if (cphHour === 23 && cphMinute >= 59) {
              // Past deadline, next Tuesday
              daysUntilTuesday = 7;
            } else {
              // Still before deadline today
              daysUntilTuesday = 0;
            }
          } else if (cphDay < 2) {
            // Sunday or Monday - Tuesday is ahead this week
            daysUntilTuesday = 2 - cphDay;
          } else {
            // Wednesday, Thursday, Friday, or Saturday - Tuesday is next week
            daysUntilTuesday = 7 - (cphDay - 2);
          }
          
          // Create deadline: now + calculated days, at 23:59:59
          // We work in UTC/local time, but the calculation is based on Copenhagen day
          const deadline = new Date(now);
          deadline.setDate(deadline.getDate() + daysUntilTuesday);
          deadline.setHours(23, 59, 59, 999);
          
          // Get the Copenhagen timezone offset to adjust the deadline
          // Create a formatter that shows timezone offset
          const copenhagenNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
          const offset = now.getTime() - copenhagenNow.getTime();
          
          // Adjust deadline by the offset so it represents 23:59:59 Copenhagen time
          this.deadline = deadline.getTime() - offset;
          
          // Mark when we last checked the deadline
          this.lastDeadlineCheck = Date.now();
        },

        /**
         * Update countdown display values
         */
        updateCountdown() {
          const now = Date.now();
          
          // Recalculate deadline every 5 minutes to avoid drift
          if (!this.lastDeadlineCheck || (now - this.lastDeadlineCheck) > 5 * 60 * 1000) {
            this.calculateDeadline();
          }
          
          const timeRemaining = this.deadline - now;
          
          if (timeRemaining <= 0) {
            // Expired - reset for next week
            this.isExpired = true;
            this.days = 0;
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
            
            // Handle expire action
            if (this.expireAction === 'hide_section') {
              this.stopCountdown();
            } else {
              // Recalculate for next week
              this.calculateDeadline();
            }
            return;
          }
          
          // Calculate time components
          const totalSeconds = Math.floor(timeRemaining / 1000);
          const totalMinutes = Math.floor(totalSeconds / 60);
          const totalHours = Math.floor(totalMinutes / 60);
          const totalDays = Math.floor(totalHours / 24);
          
          this.days = totalDays;
          this.hours = totalHours % 24;
          this.minutes = totalMinutes % 60;
          this.seconds = totalSeconds % 60;
          
          this.isExpired = false;
        },

        /**
         * Start the countdown timer
         */
        startCountdown() {
          // Clear any existing interval
          if (this.interval) {
            clearInterval(this.interval);
          }
          
          // Update every second
          this.interval = setInterval(() => {
            this.updateCountdown();
          }, 1000);
        },

        /**
         * Stop the countdown timer
         */
        stopCountdown() {
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        }
      }));
    console.log('[Countdown] Component registered successfully');
  }

  // Hybrid registration: handle both early and late loading
  if (window.Alpine) {
    // Alpine already loaded - register immediately
    console.log('[Countdown] Alpine already loaded, registering immediately');
    registerCountdownComponent();
  } else {
    // Alpine not yet loaded - wait for init event
    console.log('[Countdown] Waiting for alpine:init event');
    document.addEventListener('alpine:init', () => {
      console.log('[Countdown] alpine:init fired, registering now');
      registerCountdownComponent();
    });
  }
}
